export default "__VITE_ASSET__Bl7j4yXo__"